import React, { useCallback, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashboardPageHeader from "components/common/DashboardPageHeader";
import TrainingDeckViewer from "components/training/TrainingDeckViewer";
import { useAuth } from "hooks/useAuth";
import { DECK_BY_ROLE } from "services/trainingDeckService";

/**
 * Optional Institution Leader orientation — not a gate for /setup/institution
 * or any other admin flow.
 */
const InstitutionLeaderOnboardingPage = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const hierarchyPath = useMemo(
    () => ({
      institutionId: userData?.institutionId || userData?.organizationId,
    }),
    [userData?.institutionId, userData?.organizationId],
  );

  const handleComplete = useCallback(async () => {
    navigate("/dashboard/prompts");
  }, [navigate]);

  return (
    <Box sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
      <DashboardPageHeader
        title="Institution Leader orientation"
        subtitle="Optional overview of institution setup, staffing roles, readiness, and governance."
      />
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        This deck is optional training. Completing it is not required to use the dashboard,
        role roster, domains, or institution setup.
      </Typography>
      <TrainingDeckViewer
        deckId={DECK_BY_ROLE.admin}
        userHierarchyPath={hierarchyPath}
        onComplete={handleComplete}
      />
    </Box>
  );
};

export default InstitutionLeaderOnboardingPage;
